/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect, useMemo } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import { set } from "lodash";

const useSegmento = (grupoSegmento = 0, formikRef, segmentosDisponiveis, config = {}) => {
  const {
    salvarLocalStorage,
    chave
  } = config;

  const segmentoSelect = useSelect("segmento");
  const [fila, setFila] = useState(null);
  const [onSegmento, setOnSegmento] = useState(false);
  const [segmento, setSegmento] = useState(0);

  const [segmentos, setSegmentos] = useState([]);

  useEffect(() => {
    const fetchSegmentos = async () => {
      let wheres = 0;
      if (!grupoSegmento) return setSegmentos([]);

      let query = db.segmento;

      if (grupoSegmento > 0) {
        query = query.where("grupoSegmentoId").equals(grupoSegmento);
        wheres++;
      }

      if (segmentosDisponiveis) {
        if (wheres > 0) {
          query = query.and(s => segmentosDisponiveis.includes(s.id));
        } else {
          query = query.where("id").anyOf(segmentosDisponiveis);
        }
      }

      const results = [];
      await query.filter((a) => a.ativo).each((item) => results.push(item));
      setSegmentos(results);
    };

    fetchSegmentos();
  }, [grupoSegmento, segmentosDisponiveis]);

  useEffect(() => {
    if (grupoSegmento && grupoSegmento != 0) {
      const exists = (segmentos || []).find(e => e.grupoSegmentoId == grupoSegmento);

      if (!exists) {
        onChangeSegmento({
          value: null
        })
      }
    }
  }, [grupoSegmento]);

  const optionsSegmento = useMemo(() => prepareForOptions((segmentos || []).sort((a, b) => a.nome.localeCompare(b.nome)), ["nome"], "id"), [segmentos]);

  function onChangeSegmento(e) {
    setOnSegmento(e.value > 0);
    segmentoSelect.upDateValue(e.value);
    segmentoSelect.upDateDefaultValue(e || "");
    if (e && e.value && salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }

    if (formikRef?.current) {
      formikRef.current.setFieldValue("segmentoId", e.value);
      setTimeout(() => formikRef?.current && formikRef.current.setFieldTouched("segmentoId", true));
    }

    setSegmento(e.value);
  }

  function SetSelectSegmento(id, setSegmentosInitialized = undefined) {
    if (optionsSegmento?.length) {
      const segmento = optionsSegmento.find((item) => item.value == id);
      if (segmento) {
        onChangeSegmento(segmento)
        if (setSegmentosInitialized !== undefined) setSegmentosInitialized(true);
      }
      setFila(null)
    } else {
      setFila(id);
    }
  }

  useEffect(() => {
    if (fila && optionsSegmento?.length > 0) {
      SetSelectSegmento(fila);
    }
  }, [fila, optionsSegmento])

  function CleanForFilter(option) {
    onChangeSegmento(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }

  useEffect(() => {
    if(salvarLocalStorage){
      const cidade = localStorage.getItem(chave);

    if (cidade) {
      const filialObj = JSON.parse(cidade);

      onChangeSegmento(filialObj);
      setSegmento(filialObj.value);
    }
    }
  }, [])

  return {
    optionsSegmento,
    segmentos,
    segmentoSelect,
    onChangeSegmento,
    SetSelectSegmento,
    segmento,
    onSegmento,
    CleanForFilter
  };
}

export default useSegmento;